import {useEffect, useState} from "react";
import {Button, Card, Col, Row, Table, Tag} from "antd";
import {useTranslation} from "react-i18next";
import {convertToUppercase, formatDateTime, useIsMobile} from "../../../../../_common/function";
import {getStatusColor} from "../../../common";
import {useGetUserVerificationHistories} from "../../../function/accountVerification";
import {EyeOutlined} from "@ant-design/icons";
import VerificationHistoryModal_3 from "./verificationHistoryModal";
import {isArray} from "lodash";

const VerificationHistory_3 = ({userVerificationTiers, currentTab}) => {
    const {t} = useTranslation();
    const lang = localStorage.getItem("language") || "en";
    const {getUserVerificationHistories} = useGetUserVerificationHistories();
    const [histories, setHistories] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const [filter, setFilter] = useState({});
    const [sort, setSort] = useState({createdAt: -1});
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);

    const [isViewOpen, setIsViewOpen] = useState(false);
    const [viewingRecord, setViewingRecord] = useState(null);

    const isMobile = useIsMobile()

    const fetchHistories = async () => {
        setLoading(true)
        try {
            const result = await getUserVerificationHistories({
                filter,
                sort,
                limit,
                offset,
                populate: ["flowSetting", "tierSetting"]
            });

            if (result?.status === "Success") {
                setHistories(result?.data);
                setTotal(result?.total)
            }

        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchHistories();
    }, [filter, sort, limit, offset, getUserVerificationHistories, currentTab])

    const columns = [
        {
            title: t("accountVerification.verificationType"),
            key: "verificationType",
            render: (_, record) => {
                return convertToUppercase(record?.flowSetting?.verificationType || "-");
            }
        },
        {
            title: t("accountVerification.name"),
            key: "name",
            render: (_, record) => {
                return record?.flowSetting?.displayName?.find(name => name.language === lang)?.content || record?.flowSetting?.name;
            }
        },
        {
            title: t("Submitted at"),
            dataIndex: "updatedAt",
            key: "updatedAt",
            render: (value) => {
                return formatDateTime(value, "YYYY-MM-DD HH:mm:ss")
            }
        },
        {
            title: t("common.comment"),
            dataIndex: "comment",
            key: "comment",
            render: (value) => value ? value : "-"
        },
        {
            title: t(`common.status`),
            dataIndex: "status",
            key: "status",
            render: (value) => {
                return (
                    <Tag color={getStatusColor(value)}>
                        {t(`accountVerification.status.${value}`, {defaultValue: value})}
                    </Tag>
                )
            }
        },
        {
            title: "",
            dataIndex: "action",
            key: "action",
            render: (_, record) => (
                record?.recordType !== "old" && record?.status !== "draft_verification" && !!isArray(record?.documents) &&
                <Button
                    icon={<EyeOutlined/>}
                    type={"link"}
                    onClick={() => {
                        setIsViewOpen(true)
                        setViewingRecord(record)
                    }}
                />
            )
        }
    ]

    return (
        <>
            {
                isMobile ? histories?.map(item => (
                        <Card key={item?._id} className={"verification-history-card mb-2"} bordered={false} onClick={() => {
                            if (item?.status === "draft_verification") return
                            setIsViewOpen(true)
                            setViewingRecord(item)
                        }}>
                            <Tag color={getStatusColor(item?.status)}>
                                {t(`accountVerification.status.${item?.status}`, {defaultValue: item?.status})}
                            </Tag>
                            <Row gutter={[4, 4]} className={"mt-2"}>
                                <Col span={8}>
                                    <p><small>{t("accountVerification.verificationType")}</small></p>
                                    <p><small>{t("accountVerification.name")}</small></p>
                                    <p><small>{t("Submitted at")}</small></p>
                                    <p><small>{t("common.comment")}</small></p>
                                </Col>
                                <Col span={16}>
                                    <p><small>{convertToUppercase(item?.flowSetting?.verificationType || "-")}</small></p>
                                    <p>
                                        <small>{item?.flowSetting?.displayName?.find(name => name.language === lang)?.content || item?.flowSetting?.name}</small>
                                    </p>
                                    <p><small>{item?.status === "draft_verification" ? "-" : formatDateTime(item?.updatedAt, "YYYY-MM-DD HH:mm:ss")}</small></p>
                                    <p><small>{item?.comment || "-"}</small></p>
                                </Col>
                            </Row>
                        </Card>
                    )) :
                    <Table
                        className={"history-table"}
                        columns={columns}
                        dataSource={histories}
                        loading={loading}
                        pagination={{
                            total,
                            showTotal: (total, range) => (
                                <div
                                    style={{
                                        left: 0,
                                        position: "absolute",
                                        width: "100%",
                                        fontSize: 13,
                                        paddingLeft: 8,
                                    }}
                                >
                                    Showing {range[0]}–{range[1]} of {total} record{total > 1 && "s"}
                                </div>
                            ),
                            pageSize: limit,
                            onChange: (page) => setOffset((page - 1) * limit),
                            showSizeChanger: false,
                        }}
                    />
            }

            <VerificationHistoryModal_3
                userVerificationTiers={userVerificationTiers}
                isViewOpen={isViewOpen}
                handleClose={() => setIsViewOpen(false)}
                viewingRecord={viewingRecord}
            />
        </>
    )
}

export default VerificationHistory_3;